import Icon from '../../../common/icons/Icon.js'

export default function CustomerNotePopOver(props) {
  const {notesFromCustomer} = props

  return (
    <div className="wrap--pop-over">
      <Icon name="notepad-01" className="icon--pop-over op-50 fs-00" />
      <dl className="pop-over pop-over--below">
        <dt className="pop-over__title">Customer Notes</dt>
        <dd className="pop-over__body">
          <p className="fs-n1 lh-md margin-bottom-0">{notesFromCustomer}</p>
        </dd>
      </dl>
    </div>
  )
}
